import React, { useRef, useState } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import html2canvas from 'html2canvas';
import './OrganizationChart.scss';

const orgData = {
  mayor: {
    title: 'İskenderun Belediye Başkanı',
    name: 'MEHMET DÖNMEZ',
    image: '/assets/images/mayor.jpg',
  },
  branches: [
    {
      role: 'Makama Bağlı Müdürlükler',
      name: null,
      image: null,
      departments: [
        'Özel Kalem Md.'
      ]
    },
    {
      role: 'Belediye Bşk. Yrd.',
      name: 'Nurullah ÇEKİRDEKÇİ',
      image: '/assets/images/nurullah-cekirdekci.png',
      departments: [
        'Hukuk İşleri Md.',
        'İnsan Kaynakları ve Eğitim Md.',
        'Mali Hizmetler Md.',
        'Rehberlik ve Teftiş Kurulu Md.',
        'Strateji Geliştirme Md.',
        'Yazı İşleri Md.'
      ]
    },
    {
      role: 'Belediye Bşk. Yrd.',
      name: 'Cihan AKYÜREKOĞLU',
      image: '/assets/images/cihan-akyurekoglu.png',
      departments: [
        'Basın Yayın ve Halkla İlişkiler Md.',
        'Emlak ve İstimlak Md.',
        'Gençlik ve Spor Hizmetleri Md.',
        'İklim Değişikliği ve Sıfır Atık Md.',
        'İmar ve Şehircilik Md.',
        'İşletme ve İştirakler Md.',
        'Muhtarlıklar Md.',
        'Ruhsat ve Denetim Md.',
        'Kentsel Dönüşüm Md.',
        'Veterinerlik İşleri Md.',
        'Kültür İşleri Md.'
      ]
    },
    {
      role: 'Belediye Bşk. Yrd.',
      name: 'Bülent TEMEL',
      image: '/assets/images/bulent-temel.jpg',
      departments: [
        'Afet İşleri ve Risk Yönetimi Md.',
        'Destek Hizmetleri Md.',
        'Gelirler Müdürlüğü',
        'Park ve Bahçeler Md.'
      ]
    },
    {
      role: 'Belediye Bşk. Yrd.',
      name: 'Veli YILDIRIM',
      image: '/assets/images/veli-yildirim.png',
      departments: [
        'Bilgi İşlem Md.',
        'Fen İşleri Md.',
        'Makine İkmal Bakım ve Onarım Md.',
        'Temizlik İşleri Md.',
        'Yapı Kontrol Md.',
        'Zabıta Md.'
      ]
    }
  ]
};

const OrganizationChart = () => {
  const treeRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadImage = async () => {
    if (!treeRef.current) return;
    setIsDownloading(true);

    try {
      const canvas = await html2canvas(treeRef.current, {
        scale: 2,
        backgroundColor: '#ffffff',
        useCORS: true
      });

      const image = canvas.toDataURL('image/png', 1.0);

      const link = document.createElement('a');
      link.download = 'Iskenderun_Belediyesi_Organizasyonu.png';
      link.href = image;
      link.click();
    } catch (err) {
      console.error('Ekran görüntüsü alınırken hata oluştu:', err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="organization-chart-page mt-5">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-lg-10 col-md-7">
            <div className="organization-chart-content">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '10px' }}>
                <h1 className="page-title m-0">Organizasyon Şeması</h1>
                <button
                  className="btn"
                  style={{ backgroundColor: '#004b93', color: '#fff', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold' }}
                  onClick={handleDownloadImage}
                  disabled={isDownloading}
                >
                  {isDownloading ? 'Hazırlanıyor...' : 'PNG Olarak İndir'}
                </button>
              </div>

              <div className="org-tree-scroll-container">
                <div className="org-tree-wrapper" ref={treeRef} style={{ background: '#fff', padding: '20px' }}>
                  <div className="tree">
                    <ul>
                      <li>
                        <div className="org-card card-mayor">
                          {orgData.mayor.image && (
                            <div className="card-img-wrapper">
                              <img
                                src={orgData.mayor.image}
                                alt={orgData.mayor.name}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                              <div className="img-placeholder" style={{ display: 'none' }}>
                                {orgData.mayor.name.charAt(0)}
                              </div>
                            </div>
                          )}
                          <div className="card-name">{orgData.mayor.name}</div>
                          <div className="card-title">{orgData.mayor.title}</div>
                        </div>

                        <ul>
                          {orgData.branches.map((branch, index) => (
                            <li key={index}>
                              <div className="org-card card-vice">
                                {branch.name ? (
                                  <>
                                    {branch.image && (
                                      <div className="card-img-wrapper">
                                        <img
                                          src={branch.image}
                                          alt={branch.name}
                                          onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                          }}
                                        />
                                        <div className="img-placeholder" style={{ display: 'none' }}>
                                          {branch.name.charAt(0)}
                                        </div>
                                      </div>
                                    )}
                                    <div className="card-name">{branch.name}</div>
                                    <div className="card-title">{branch.role}</div>
                                  </>
                                ) : (
                                  <div
                                    className="card-title"
                                    style={{
                                      fontSize: '15px',
                                      fontWeight: 'bold',
                                      color: '#ff9f1c',
                                      margin: '0',
                                      height: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      textAlign: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {branch.role}
                                  </div>
                                )}
                              </div>

                              {branch.departments && branch.departments.length > 0 && (
                                <ul className="vertical-departments">
                                  {branch.departments.map((dept, deptIdx) => (
                                    <li key={deptIdx}>
                                      <div className="dept-card">{dept}</div>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationChart;
